// extracted by mini-css-extract-plugin
export default {"about":"TutorAbout_about__-zGYw"};